import React from 'react'

import FieldsCollection from "../../../../fields3/collection/base/fields-collection"
import InfoPanelRow from "../../../../gd-ui/ip-section-row/info-panel-row"
import FieldInlineEditable from "../../../../fields3/render/inline-editable"
import ProjectUser from "../../../../model2/project-user/project-user"
import ProjectUser_initProjectUserFields from "./functions/init-project-user-fields"
import ProjectUser_initWorkspaceUserFields from "./functions/init-workspace-user-fields"
import ModalUser_InheritanceNotification from "./inheritance-notification/inheritance-notification"

type Props = {
    projectUser     : ProjectUser
    projectUsers    : ProjectUser[]

    actions         : any
}

export default class ModalUserDefault extends React.Component<Props> {

    private fields: FieldsCollection

    constructor(props: Props) {
        super(props)

        const isWorkspace = gd.session.projects.get(props.projectUser.projectId)?.isWorkspace

        if (isWorkspace) {
            this.fields = ProjectUser_initWorkspaceUserFields(props.projectUser.projectId)
        } else {
            this.fields = ProjectUser_initProjectUserFields(props.projectUser.projectId)
        }
    }

    render() {
        const user = gd.session.users.get(this.props.projectUser.userId)!

        return (
            <>
                <div className="iv-header header-left header-small-no-separator">
                    <div className="title-line">
                        <div className="view-name">
                            <div className="view-name ui5-title-app-name">{user.name}</div>
                        </div>
                    </div>
                </div>

                <div className="iv-content with-left-panel">
                    <div className="ui5-info-panel big-panel m-l-10 m-r-10">

                        <div className="ip-section">
                            <ModalUser_InheritanceNotification projectUser={this.props.projectUser}/>

                            <InfoPanelRow label="Access">
                                <FieldInlineEditable field={this.fields.get('access')}
                                                     model={{
                                                         access         : this.props.projectUser.access,
                                                         projectUser    : this.props.projectUser,
                                                         projectUsers   : this.props.projectUsers
                                                     }} onChange={this.props.actions.onAccessSelect} />
                            </InfoPanelRow>

                            {[gd.const.project.role.PROJECT_MANAGER, gd.const.project.role.OWNER].includes(this.props.projectUser.projectRole) &&
                                <InfoPanelRow label="Role" contentClass="p-l-10">
                                    {this.props.projectUser.projectRole === gd.const.project.role.OWNER ? "Owner" : "Manager"}
                                </InfoPanelRow>}

                            <InfoPanelRow label="Notify on all updates">
                                <FieldInlineEditable field={this.fields.get('watchAll')} model={{watchAll: this.props.projectUser.watchAll}} onChange={this.props.actions.onWatchAllSelect} />
                            </InfoPanelRow>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
